// import "cordova-plugin-camera";
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { currentWidget } from '../../../action/action';
import { setIdCardImage, setIdCardImageBack, setIdRotateDeg, setSelectedIdType, setCheckinWidgetLaunchTime, setCheckinCurrentPageName } from '../../../action/autoCheckin';
import Header from '../../header/header';
import PicturePreview from './../PicturePreview';
import Camera from './../Camera';
import closeIcon from '../../../images/icons/close_icon.svg';
import { setGoHome } from '../../../action/homeAction'
import { withTranslation } from 'react-i18next'
import SelectDropdown from '../../../UI/SelectDropdown';
import { closeOrderPopUp } from '../../../action/hCommerce2'
import { getDefaultAnalyticsLabel } from '../../../JS/utility';
import { sendAnalytics } from '../../../../action/homeAction';
import { CMSPath } from '../../../../config/constant';
// import { setIdCardImage,setIdCardImageBack } from '../../../action/autoCheckin';
import { mobileCheckinColorConfig } from '../../../JS/colorConfig';
import { Arrow_svg, Cross_svg, Tick_svg } from './index';

class CameraModule extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showIdList: false,
      selectedId: null,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    mobileCheckinColorConfig(this.props.menuColor);
    console.log("this.props.guestDocOptions", this.props.guestDocOptions)
  }

  componentDidMount() {

    if (this.props.selectedIdType) {
      this.setState({ selectedId: this.props.selectedIdType.value })
    } else {
      let makeDefaultIndex = this.props.guestDocOptions.findIndex((options) => options.isDefault == true)
      if (makeDefaultIndex >= 0) {
        this.setState({ selectedId: this.props.guestDocOptions[makeDefaultIndex].value })
        this.props.setSelectedIdType(this.props.guestDocOptions[makeDefaultIndex]);
      }
    }

    console.log("this.props.currentWidgetObj.widgetType", this.props.currentWidgetObj.widgetType)
  }


  handleIdClick = (isBack) => {
    this.props.selectedIdType ? this.props.setShowCameraPrevForId(isBack) : this.props.closeOrderPopUp(true, "Please select the id type", "", true)
  }


  render() {
    const { t } = this.props
    return (
      <>
        <div class="form-row">
          <label>Type of ID</label>
          <SelectDropdown
            selectKey="obj.value"
            selectedItem={this.state.selectedId}
            listData={this.props.guestDocOptions}
            showList={this.state.showIdList}
            setShowList={() => {
              this.setState(prev => ({ showIdList: !prev.showIdList }))
            }}
            setSelectedItem={(obj) => {
              this.setState({ selectedId: obj.value, showIdList: false })
              this.props.setSelectedIdType(obj);
              this.props.setIdCardImage(null)
              this.props.setIdCardImageBack(null)
            }}
          />
        </div>

        <div class={`id-verification ${!this.props.idCardImage ? "current-focus" : ""}`} id="id-front"
          onClick={() => this.handleIdClick(false)}
        >
          <div class={`icon-status ${this.props.idCardImage ? "complete" : "incomplete"}`}>
            {this.props.idCardImage ? <> <Tick_svg /></> : <Cross_svg />}
          </div>

          <div class="text">
            <div class="heading">
              {(this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired) ? t('pre_checkIn.identity_verification_front_heading', { defaultValue: 'Photograph front of your ID' }) : t('pre_checkIn.identity_verification_photograph', { defaultValue: 'Photograph your ID' })}
            </div>
            <div class="subheading">
            {t('pre_checkIn.identity_verification_front_subheading', { defaultValue: 'Follow the instructions and take a picture of your ID.' })}
            </div>
          </div>
          <div class="arrow-sign">
            <Arrow_svg />
          </div>
        </div>

        {
          (this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired) &&

          <div class={`id-verification ${this.props.idCardImage && !this.props.idCardImageBack ? "current-focus" : ""}`} id="id-back"
            onClick={() => this.handleIdClick(true)}
          >
            <div class={`icon-status ${this.props.idCardImageBack ? "complete" : "incomplete"}`}>
              {this.props.idCardImageBack ? <Tick_svg /> : <Cross_svg />}
            </div>

            <div class="text">
              <div class="heading">
              {t('pre_checkIn.identity_verification_back_heading', { defaultValue: 'Photograph back of your ID' })}
              </div>
              <div class="subheading">
              {t('pre_checkIn.identity_verification_back_subheading', { defaultValue: 'Follow the instructions and take a picture of your ID.' })}
              </div>
            </div>
            <div class="arrow-sign">
              <Arrow_svg />
            </div>
          </div>
        }
      </>


    )
  }
}
const mapStateToProps = state => {
  return {
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    selectedIdType: state.store2.selectedIdType,
    idCardImage: state.store2.idCardImage,
    idCardImageBack: state.store2.idCardImageBack,
    idRotateDeg: state.store2.id_rotate_deg,
    menuColor: state.store.home.MenuColor,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDocOptions: state.store.guestDocOptions
  }
}
export default connect(
  mapStateToProps,
  {

    setIdCardImage,
    setIdCardImageBack,
    setGoHome,
    closeOrderPopUp,
    setSelectedIdType,
    sendAnalytics,
    setCheckinWidgetLaunchTime,
    setCheckinCurrentPageName
  }
)(withTranslation('translations')(CameraModule));
